import { I18n } from 'aws-amplify';
import en from 'src/i18n/en';
import es from 'src/i18n/es';

I18n.setLanguage(navigator.language || navigator.userLanguage);
I18n.putVocabularies({
    en,
    es,
});
